module.exports = __webpack_public_path__ + "img/svg/garage-truck-f3963347.svg";